import { SyntheticEvent } from 'react';
import { Stack } from '@mui/material';

import { ConfirmDialog, Typography, CircularProgress, snackbar } from '@occc-app/design-system';

import { useTobaccoApiOfferUpcs } from '../use-tobacco-api-offer-upcs.hook';

type UpcListDialogProps = {
  open: boolean;
  onClose: (event: SyntheticEvent) => void;
  offerUuid: string;
};

export const UpcListDialog = ({ open, onClose, offerUuid }: UpcListDialogProps) => {
  const { parRetailUpcs, apiUpcs, loading, error } = useTobaccoApiOfferUpcs(offerUuid, !open);

  const handleCopyUpcs = async () => {
    const allUpcs = [...parRetailUpcs, ...apiUpcs].join(', ');
    try {
      await navigator.clipboard.writeText(allUpcs);
      snackbar.success('UPCs copied to clipboard');
    } catch {
      snackbar.error('Failed to copy UPCs to clipboard');
    }
  };

  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      confirmButtonText='COPY UPCs'
      confirmButtonProps={{ onClick: handleCopyUpcs, sx: { textTransform: 'none' }, disabled: loading || !!error }}
      maxWidth='sm'
      fullWidth
    >
      {loading ? (
        <CircularProgress />
      ) : error ? (
        <Typography variant='body1' color='error'>
          Failed to load UPCs. Please close and try again.
        </Typography>
      ) : (
        <Stack spacing={2}>
          <div>
            <Typography variant='subtitle1' fontWeight='medium'>
              PAR Retail created UPCs
            </Typography>
            <Typography variant='body1'>
              {parRetailUpcs.length > 0 ? parRetailUpcs.join(', ') : 'None'}
            </Typography>
          </div>
          <div>
            <Typography variant='subtitle1' fontWeight='medium'>
              API created UPCs
            </Typography>
            <Typography variant='body1'>
              {apiUpcs.length > 0 ? apiUpcs.join(', ') : 'None'}
            </Typography>
          </div>
        </Stack>
      )}
    </ConfirmDialog>
  );
};
